import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { CRUMB_LABEL_KEY, NAME } from '../constants';
import { apiProvider } from '../api';

const filter = {
	TelfmaNr: null as string | null,
	Kns: null as number | null,
	Obec: null as string | null,
	Ulice: null as string | null,
	TelmobNr: null as string | null,
	Jmeno: null as string | null,
	Text: null as string | null,
	IcoNr: null as number | null,
	TelprivNr: null as number | null,
	DicNr: null as string | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
